<form *ngIf="employeeForm" [formGroup]="employeeForm" [attr.data-test-id]="testId + '.form'">

    <div class="m-form__group" formArrayName="employeeAdd">
        <h2 class="section-title" [attr.data-test-id]="testId + '.title'">Employment History</h2>
        <ng-container
            *ngFor="let employee of employements.controls; let i = index">
            <div [formGroupName]="i">
                <p class="mb-4 mt-4 font-16px" *ngIf="i === 1 && finalSubmitPages?.employmentHistoryDuration"
                   [attr.data-test-id]="testId + '.prior-employment-message'">
                    Please add prior employment information. Minimum {{finalSubmitPages.employmentHistoryDuration}} months employment
                    history is required.
                </p>
                <div class="row">
                    <div class="{{cssWidthClass}}">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-label [attr.data-test-id]="testId + '.employment-type-label.' + i">Employment Type</mat-label>
                            <mat-select name="empType" id="empType_{{i}}" required
                                        formControlName="employeeType" (selectionChange)="onEmploymentStatusChange($event, i)"
                                        [attr.data-test-id]="testId + '.employment-type-select.' + i">
                                <mat-option *ngFor="let status of appConfig.employmentTypeList"
                                            [value]="status.value" id="{{status.name}}"
                                            [attr.data-test-id]="testId + '.employment-type-option.' + status.value?.toLowerCase()">{{status.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error [attr.data-test-id]="testId + '.employment-type.required-error.' + i">Please select employment type.</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="{{cssWidthClass}}" *ngIf="!finalSubmitPages?.hideEmploymentHistoryDuration">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-label [attr.data-test-id]="testId + '.employment-length-label.' + i">{{employmentLengthPlaceholder}}</mat-label>
                            <creditsnap-yearmonth #yearmonth id="employmentLength_{{i}}" formControlName="employmentLength"
                                (focusout)="checkYears($event, i)"
                                [data-test-id]="testId + '.employment-length.' + i"
                                [groupLabel]="employmentLengthPlaceholder"
                            ></creditsnap-yearmonth>
                            <mat-error [attr.data-test-id]="testId + '.employment-length.required-error.' + i">Please enter {{employmentLengthPlaceholder}}.</mat-error>
                            <mat-hint [attr.data-test-id]="testId + '.employment-length-hint.' + i">Enter the {{employmentLengthPlaceholder}} in years and months.</mat-hint>
                        </mat-form-field>
                    </div>

                    <div *ngIf= "!hideEmployerName" class="{{cssWidthClass}}">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-label [attr.data-test-id]="testId + '.employer-name-label.' + i">{{employerNameTitlePlaceholder}}</mat-label>
                            <input matInput type="text"
                                   name="empName" id="empName_{{i}}" required
                                   formControlName="employerName" autocomplete="organization"
                                   [attr.data-test-id]="testId + '.employer-name-input.' + i"/>
                            <mat-error *ngIf="employee.get('employerName')?.errors?.['required']"
                                       [attr.data-test-id]="testId + '.employer-name.required-error.' + i">Please enter employer name.</mat-error>
                            <mat-error *ngIf="employee.get('employerName')?.errors?.['maxlength']"
                                       [attr.data-test-id]="testId + '.employer-name.maxlength-error.' + i">Employer name must not exceed 40 characters.</mat-error>
                            <mat-error *ngIf="employee.get('employerName')?.errors?.['pattern']"
                                       [attr.data-test-id]="testId + '.employer-name.pattern-error.' + i">Only letters, numbers, spaces, hyphens, periods, commas, and ampersands are allowed.</mat-error>
                        </mat-form-field>
                    </div>

                    <div *ngIf= "!hidePosition && !(i === 0 && hidePrimaryJobTitle)" class="{{cssWidthClass}}">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-label [attr.data-test-id]="testId + '.job-title-label.' + i">{{jobTitlePlaceholder}}</mat-label>
                            <input matInput type="text"
                                   name="position" id="position_{{i}}"
                                   formControlName="position" autocomplete="organization-title"
                                   [attr.data-test-id]="testId + '.job-title-input.' + i"/>
                            <mat-error *ngIf="employee.get('position')?.errors?.['required']"
                                       [attr.data-test-id]="testId + '.job-title.required-error.' + i">Please enter {{jobTitlePlaceholder}}.</mat-error>
                            <mat-error *ngIf="employee.get('position')?.errors?.['maxlength']"
                                       [attr.data-test-id]="testId + '.job-title.maxlength-error.' + i">Job title must not exceed 40 characters.</mat-error>
                            <mat-error *ngIf="employee.get('position')?.errors?.['pattern']"
                                       [attr.data-test-id]="testId + '.job-title.pattern-error.' + i">Only letters, numbers, spaces, hyphens, periods, commas, and ampersands are allowed.</mat-error>
                        </mat-form-field>
                    </div>

                    <div *ngIf="employements.controls.length > 1 && i != 0"
                         class="col-sm-2">
                        <a mat-flat-button matTooltip="Delete" (click)="removeEmployee(i)" id="removePreviousEmployeeHistory"
                           [attr.data-test-id]="testId + '.remove-entry-button.' + i">
                            <sm-icon name="trash" [width]="24" [height]="24"></sm-icon>
                        </a>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</form>
